import { MenuOptions, ShopTabsOptions } from 'types';
import { translations } from 'translations/en';

export const ShopPageTabs = [
  {
    key: ShopTabsOptions.Home,
    label: translations.SHOP.HOME,
    isTokenRequired: false,
  },
  {
    key: ShopTabsOptions.Catalog,
    label: translations.SHOP.CATALOG,
    isTokenRequired: false,
  },
  {
    key: ShopTabsOptions.Mojos,
    label: translations.SHOP.MOJOS,
    isTokenRequired: true,
  },
  {
    key: ShopTabsOptions.Activity,
    label: translations.SHOP.ACTIVITY,
    isTokenRequired: true,
  },
  {
    key: ShopTabsOptions.Reviews,
    label: translations.SHOP.REVIEWS,
    isTokenRequired: true,
  },
];

export const CATALOG_ITEM_DROPDOWN_OPTIONS = [
  { key: MenuOptions.Edit, label: translations.COMMON.EDIT, danger: false },
  { key: MenuOptions.Duplicate, label: translations.COMMON.DUPLICATE, danger: false },
  { key: MenuOptions.Delete, label: translations.COMMON.DELETE, danger: true },
];
